<div class="fixed inset-0 -z-10 bg-gray-100"></div>
<div class="flex flex-col h-full w-full space-y-4">
  <div class="py-3 drop-shadow-2xl">
    <img alt="CheqMe Logo" class="mx-auto h-32 w-auto rounded-full border-2 border-white" src="assets/images/icon.png">
  </div>
  <div class="h-full py-8">
    <router-outlet class=""></router-outlet>
  </div>
</div>
